import React, { useEffect, useState,useRef } from "react";
// import { useDispatch } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { getProfileBasicInfo } from "../../../../services/medium";
import StarsRating from "stars-rating";
// import BookingPopUp from "./bookingpopup";
import "./profile.css";
import { deleteUserFeedbacks } from "../../../../services/admin";
import { getMediumPublicProfileDetails } from "../../../../services/uidata";
import { getMediumFeedbacksList, getPractitionarInfo } from "../../../../services/client";
import { isHTML, screenNameHandler } from "../../../../utils/helpers";
import { get } from "immutable";

const generateSrcDoc = (htmlBody) => `
  <html>
    <head>
    <link rel="stylesheet" href="/fonts/style.css" />
     <style>
        body {
          margin: 0;
          font-family: "Oakes-Grotesk-Medium";
          font-size : 14px;
          color: #555;
        }
      </style>
    </head>
    <body>
      ${htmlBody}
      <script>
        function sendHeight() {
          const height = document.body.scrollHeight;
          parent.postMessage({ type: 'setHeight', height }, '*');
        }
        window.onload = sendHeight;
        window.onresize = sendHeight;
      </script>
    </body>
  </html>
`;
export default function MediumProfileView({ onClick ,show }) {
    const navigate = useNavigate();
    const params = useParams()
    // const dispatch = useDispatch();
    //const [profile, setProfile] = useState(null);
    const [searchParams] = useSearchParams();
    const from = searchParams.get("from");
    const serviceValue = searchParams.get("serviceValue");
    const [profileSection, setProfileSection] = useState(null);
    const iframeRef = useRef(null);
        const [iframeHeight, setIframeHeight] = useState("100px");
          useEffect(() => {
            const handleMessage = (event) => {
                if (event.data && event.data.type === "setHeight") {
                    let height =  event.data.height + 65;
                setIframeHeight(height + "px");
                }
            };

            window.addEventListener("message", handleMessage);
            return () => window.removeEventListener("message", handleMessage);
            }, []);
    //const [teachnologySection, setteachnologySection] = useState(null);
    //const [preferncesSection, setpreferncesSection] = useState(null);

    //const params = useParams();

    useEffect(() => {
        // dispatch(setPathArray(params.id));
        getProfile();
        // getPreferences();
        // getTechnologies();
        // return () => {
        // dispatch(setPathArray(null));
        // };
    }, []);

    const getProfile = () => {
        getPractitionarInfo(params.id)
            .then((data) => {
                setProfileSection(data.data.data);
            })
            .catch((err) => console.log(err));
    };

    // Client Reviews pagination: get-medium-details only sends the first 2
    // feedback entries (feedbacks_has_more tells us if there's more), so once
    // the profile loads we seed the reviews list from that instead of firing
    // a second request. The "Load" button then fetches 5 more at a time from
    // the dedicated paginated feedbacks API.
    const LOAD_MORE_REVIEWS_LIMIT = 5;
    const [reviews, setReviews] = useState([]);
    const [reviewsOffset, setReviewsOffset] = useState(0);
    const [hasMoreReviews, setHasMoreReviews] = useState(false);
    const [loadingReviews, setLoadingReviews] = useState(false);
    const loadMoreRef = useRef(null);

    useEffect(() => {
        if (profileSection && profileSection.feedbacks) {
            setReviews(profileSection.feedbacks);
            setReviewsOffset(profileSection.feedbacks.length);
            setHasMoreReviews(!!profileSection.feedbacks_has_more);
        }
    }, [profileSection]);

    const loadMoreReviews = () => {
        const medium_id = profileSection && profileSection.general ? profileSection.general.medium_id : undefined;
        if (!medium_id) return;
        setLoadingReviews(true);
        getMediumFeedbacksList(medium_id, reviewsOffset, LOAD_MORE_REVIEWS_LIMIT)
            .then((data) => {
                if (data.data.status) {
                    const { feedbacks: newFeedbacks, has_more, offset: returnedOffset, limit: returnedLimit } = data.data.data;
                    setReviews((prev) => [...prev, ...newFeedbacks]);
                    setReviewsOffset(returnedOffset + returnedLimit);
                    setHasMoreReviews(has_more);
                }
            })
            .catch(() => { })
            .finally(() => setLoadingReviews(false));
    };

    // Infinite scroll: auto-load the next page of reviews when the sentinel
    // at the bottom of the list scrolls into view (replaces the "Load" button).
    useEffect(() => {
        if (!hasMoreReviews) return;
        const el = loadMoreRef.current;
        if (!el) return;
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && !loadingReviews) {
                    loadMoreReviews();
                }
            },
            { root: null, rootMargin: "200px", threshold: 0 }
        );
        observer.observe(el);
        return () => observer.disconnect();
    }, [hasMoreReviews, loadingReviews, reviewsOffset]);

    // NOTE: the star rating used to be computed here from
    // profileSection.feedbacks, but get-medium-details only sends the first 2
    // feedback entries (for load time), so the average is computed
    // server-side and returned as profileSection.general.average_rating.
    // const getPreferences = () => {
    //     getProfilePreferences()
    //         .then((data) => {

    //             setpreferncesSection(data.data.data);
    //         })
    //         .catch((err) => console.log(err));
    // };
    // const getTechnologies = () => {
    //     getProfileTechnology()
    //         .then((data) => {
    //             setteachnologySection(data.data.data);
    //         })
    //         .catch((err) => console.log(err));
    // };
        const getBio = (info) =>{
        const rawContentFromDB = info
        let html;
      if (!isHTML(rawContentFromDB)) {
        let info =
          rawContentFromDB
            .split("\n")
            .map(line => `${line}`)
            .join("");
        console.log(info, "cejdncjkm");
        html = info
        return info
      }
      else {

        html = JSON.parse(rawContentFromDB).content
        return <div dangerouslySetInnerHTML={{ __html: JSON.parse(rawContentFromDB).content }} />
      }

  }
  const getInfo = (info) => {

                const rawContentFromDB = info
                let html;
                if (!isHTML(rawContentFromDB)) {
                    console.log( info,"ckejdnm1")
                    let info =
                        rawContentFromDB
                            .split("\n")
                            .map(line => `${line}`)
                            .join("");
                    console.log(info, "cejdncjkm");
                    html = info
                    return info
                }
                else {
                   // console.log( info,"ckejdnm2")
                    // html = JSON.parse(rawContentFromDB).content
                    // return <div dangerouslySetInnerHTML={{ __html: rawContentFromDB }} />

                      html = JSON.parse(rawContentFromDB).content
                      const srcDoc = generateSrcDoc(html);
                    return srcDoc
                }

        // "{\"content\":\"<p style=\\\"margin-left:0px;\\\">Try a Community Support Group:</p>\\n<ol>\\n<li><span style=\\\"font-size: 12px;font-family: Helvetica;\\\">Male Mediums - Ed S. Mediums Who Speak French - Cindy L.</span></li>\\n<li style=\\\"margin-left:0px;\\\"><span style=\\\"font-size: 12px;font-family: Helvetica;\\\">Unsupported: Doubt/Fear from Family/Friends = Lisa A.</span></li>\\n<li style=\\\"margin-left:0px;\\\"><span style=\\\"font-size: 12px;font-family: Helvetica;\\\">Unity: Group Meditation - Amber K. Healing Session for Mediums - Catherine B.</span></li>\\n</ol>\\n\"}"

            }
    return (
        <div className="container-fluid px-2 px-md-4 py-3 schedule-advance-box-all-container">
            <div className="single-profile-saction single-profile-saction-new">

                {/* Back button */}
                {show == undefined && (
                    <div onClick={() => navigate(-1)} className="back-btn-profile mb-3">
                        {from !== "booking" && (
                            <div className="bac-href pointer d-inline-flex align-items-center" style={{ gap: '6px' }}>
                                <img className="bac-img" src="/images/arrow-back.png" alt="back" style={{ position: 'static', top: 'auto', margin: 0 }} />
                                Go Back
                            </div>
                        )}
                    </div>
                )}

                {/* Profile card */}
                <div className="profile-all-box">

                    {/* Banner */}
                    <div className="banner-img-profile">
                        <img
                            src="/images/profile-cover.png"
                            alt="avatar"
                            style={{ width: '100%', height: '200px', objectFit: 'cover', borderRadius: '11px 11px 0 0', border: 'none' }}
                        />
                    </div>

                    {/* Profile header row */}
                    <div className="px-3 px-md-4">
                        <div className="row align-items-start">
                            {/* Avatar */}
                            <div className="col-auto">
                                <div className="profile-image" style={{ marginTop: '-50px' }}>
                                    <img
                                        className="public-profile-picture"
                                        src={
                                            profileSection !== null && profileSection.general.profile_image !== ""
                                                ? process.env.REACT_APP_IMAGE_URL + profileSection.general.profile_image
                                                : "/images/user-dummy.png"
                                        }
                                        alt="avatar"
                                    />
                                </div>
                            </div>

                            {/* Name + stars */}
                            <div className="col" style={{ minWidth: 0 }}>
                                <div className="profile-name">
                                    <div className="nam-prof">
                                        {profileSection !== null && screenNameHandler(profileSection.general.first_name, profileSection.general.last_name)}
                                    </div>
                                    {/* <a href="#">
                                        {profileSection !== null && screenNameHandler(profileSection.general.first_name, profileSection.general.last_name)}
                                    </a> */}
                                    <div className="star-rating">
                                        {profileSection !== null && (
                                            <StarsRating
                                                count={5}
                                                value={profileSection.general.average_rating || 0}
                                                size={20}
                                                color2={"#ffc107"}
                                                edit={false}
                                                color1={"gray"}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Book Here button */}
                            {from !== "booking" && (
                                <div className="col-12 col-sm-auto mt-2 mt-sm-3">
                                    <div className="profile-book-now" style={{ float: 'none', width: '100%', padding: 0 }}>
                                        <a
                                            className="book-now-practice d-block text-center"
                                            style={{ padding: '10px 28px' }}
                                            href={
                                                profileSection !== null && profileSection.personal_booking_link !== ""
                                                    ? profileSection.personal_booking_link
                                                    : "#"
                                            }
                                        >
                                            Book Here
                                        </a>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Languages, Specialities, Country */}
                    <div className="profile-details app-new-profile-details px-3 px-md-4 mt-3">
                        <ul className="list-unstyled mb-0">
                            <li className="d-flex align-items-start mb-3">
                                <div className="icon-detls flex-shrink-0 mr-3">
                                    <img src="/images/chate.png" alt="" />
                                </div>
                                <div style={{ minWidth: 0, flex: 1 }}>
                                    <em style={{ display: 'block' }}>Languages Available for Mediumship Sessions:</em>
                                    <div style={{ flexWrap: 'wrap', gap: '6px', marginTop: '6px' }}>
                                        {profileSection !== null && profileSection.general.languages.map((data) => (
                                            <span key={data.lanugage_name} style={{ display: 'inline-block', border: '1px solid #D5A67B', borderRadius: '5px', padding: '2px 12px', fontSize: '14px', lineHeight: '26px' }}>{data.lanugage_name}</span>
                                        ))}
                                    </div>
                                </div>
                            </li>

                            {parseInt(serviceValue) !== 2 && (
                                <li className="d-flex align-items-start mb-3">
                                    <div className="icon-detls flex-shrink-0 mr-3">
                                        <img src="/images/present.png" alt="" />
                                    </div>
                                    <div style={{ minWidth: 0, flex: 1 }}>
                                        <em style={{ display: 'block' }}>Mediumship Specialities:</em>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '6px' }}>
                                            {profileSection !== null && profileSection.general.specialities.map((data) => (
                                                <span key={data.specialty_name} style={{ display: 'inline-block', border: '1px solid #D5A67B', borderRadius: '5px', padding: '2px 12px', fontSize: '14px', lineHeight: '26px' }}>{data.specialty_name}</span>
                                            ))}
                                        </div>
                                    </div>
                                </li>
                            )}

                            <li className="d-flex align-items-center mb-3">
                                <div className="icon-detls flex-shrink-0 mr-3">
                                    <img src="/images/word.png" alt="" />
                                </div>
                                <em>Country:</em>
                                &nbsp;<a href="#" style={{ color: '#D5A67B' }}>{profileSection !== null && profileSection.general.country}</a>
                            </li>
                        </ul>
                    </div>

                    {/* About Me (coaching view only) */}
                    {parseInt(serviceValue) === 2 && profileSection !== null && profileSection.general.biographical_info !== "" && (
                        <div className="profile-bio px-3 px-md-4">
                            <h2>About Me</h2>
                            <iframe
                                ref={iframeRef}
                                srcDoc={getInfo(profileSection.general.biographical_info)}
                                style={{ width: '100%', height: iframeHeight, border: 'unset' }}
                                title="Editor Preview"
                            />
                        </div>
                    )}

                    {/* Reviews section */}
                    <div className="profile-bio px-3 px-md-4">
                        {parseInt(serviceValue) === 2 && (
                            <>
                                <button
                                    type="button"
                                    className="btn btn-primary bg-theme-d5a67b height-35 d-block mb-5 width-245px"
                                    data-toggle="modal"
                                    data-target=".bd-example-modal-lg"
                                >
                                    About Our Reviews
                                </button>

                                <div
                                    className="modal fade bd-example-modal-lg mt-5"
                                    tabIndex="-1"
                                    role="dialog"
                                    aria-labelledby="myLargeModalLabel"
                                    aria-hidden="true"
                                >
                                    <div className="modal-dialog modal-lg modal-dialog-preview">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title" id="exampleModalLabel">About Our Reviews</h5>
                                                <button
                                                    type="button"
                                                    className="close about-us-review-close"
                                                    data-dismiss="modal"
                                                    aria-label="Close"
                                                >
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body p-5">
                                                <p className="review-Popup">
                                                    In an effort to be as transparent as possible, Mediums who have completed a sufficient number of sessions can publish recent reviews from clients (we remove identifying information and confidential details). We don't cherry pick reviews or publish just the positive ones.
                                                </p>
                                                <br />
                                                <p className="review-Popup">
                                                    We hope you will recognize both the quality of our Mediums and that mediumship is not an exact science and does not work perfectly every time, even for the most experienced Mediums. This balanced view of recent client experiences should give you a sense of the Medium's style and results.
                                                </p>
                                                <br />
                                                <p className="review-Popup">
                                                    We applaud our Mediums for choosing to publish their reviews, blemishes and all, to help bring more transparency to the mediumship profession.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}

                        <h2 className="mb-3">Client Reviews</h2>

                        <div className="feedback-container">
                            {reviews.map((feedback, idx) => (
                                <div key={idx} className="feedback-border-feed row border-bottom py-3 mx-0 mt-2">
                                    <div className="col-12 col-md-4 mb-2 mb-md-0">
                                        <div className="d-flex align-items-center">
                                            <div className="feedback-image flex-shrink-0">
                                                <img
                                                    className="practioner-profile-image"
                                                    src="../images/user-dummy.png"
                                                    alt="avatar"
                                                />
                                            </div>
                                            <span className="ml-2" style={{ fontSize: '14px' }}>
                                                {feedback.client_name} — {JSON.parse(feedback.feedback).Country}
                                            </span>
                                        </div>
                                        <div className="feedback-star-image mt-1">
                                            <StarsRating
                                                count={5}
                                                value={parseInt(JSON.parse(feedback.feedback).Star_Rating)}
                                                size={20}
                                                color2={"#ffc107"}
                                                edit={false}
                                                color1={"#ffffff"}
                                            />
                                        </div>
                                        <p className="feedback-date mb-0">{feedback.feedback_date}</p>
                                    </div>
                                    <div className="col-12 col-md-8">
                                        <span className="feedback-heading d-block">{JSON.parse(feedback.feedback).Title}</span>
                                        <span style={{ fontSize: '14px', color: '#555' }}>{JSON.parse(feedback.feedback).Publishable_Feedback}</span>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {hasMoreReviews && (
                            <div ref={loadMoreRef} style={{ height: 1 }} />
                        )}
                        {loadingReviews && (
                            <div className="text-center mt-3" style={{ fontSize: "14px", color: "#555" }}>
                                Loading…
                            </div>
                        )}
                    </div>

                </div>
            </div>
        </div>
    );
}
